import axios from "axios";
import { getToken } from "./AuthHelper";
import { getHost } from './utils'

const SERVER_URL = getHost();

/*const get = (route, params, onSuccess, onError) => {
    axios({ method:'GET', 
        url: `${SERVER_URL}/api/${route}`, 
        data: params
    })
    .then((response) => {
        onSuccess(response.data)
    })
    .catch((error) => {
        onError(error)
    });
}*/

const post = (route, params, onSuccess, onError) => {
    axios({ method:'POST', 
        url: `${SERVER_URL}/api/${route}`, 
        headers: { authorization: `Bearer ${getToken()}` },
        data: params
    })
    .then((response) => {
        onSuccess(response.data)
    })
    .catch((error) => {
        onError(error)
    });
}

const getInterviews = (params, onSuccess, onError = ()=>{}) => {
    post('getInterviews', params, onSuccess, onError)
}

const addInterview = (params, onSuccess, onError = ()=>{}) => {
    post('addInterview', params, onSuccess, onError)
}

const editInterview = (params, onSuccess, onError = ()=>{}) => {
    post('editInterview', params, onSuccess, onError)
}

const deleteInterview = (params, onSuccess, onError = ()=>{}) => {
    post('deleteInterview', params, onSuccess, onError)
}

const addReply = (params, onSuccess, onError = ()=>{}) => {
    post('addReply', params, onSuccess, onError)
}

const getInterviewsNew = (params, onSuccess, onError = ()=>{}) => {
    post('getInterviewsNew', params, onSuccess, onError)
}

const toggleReactionInterview = (params, onSuccess, onError = ()=>{}) => {
    post('toggleReactionInterview', params, onSuccess, onError)
}

const addInterviewCapReply = (params, onSuccess, onError = ()=>{}) => {
    post('addInterviewCapReply', params, onSuccess, onError)
}

const saveInterviewRecap = (params, onSuccess, onError = ()=>{}) => {
    post('saveInterviewRecap', params, onSuccess, onError)
}

const createInterviewRecap = (params, onSuccess, onError = ()=>{}) => {
    post('createInterviewRecap', params, onSuccess, onError)
}

const api = {
    getInterviews,
    addInterview,
    editInterview,
    deleteInterview,
    addReply,

    getInterviewsNew,
    toggleReactionInterview,
    addInterviewCapReply,
    saveInterviewRecap,
    createInterviewRecap
};
export default api;